import styled from 'styled-components';

export const BtnWrapper = styled.div`
	width: 100vw;
	display: flex;
	justify-content: center;
	margin-top: 15px;
`;
